import { render, staticRenderFns } from "./OrderTypeSelect.vue?vue&type=template&id=4600c6de&scoped=true&"
import script from "./OrderTypeSelect.vue?vue&type=script&lang=js&"
export * from "./OrderTypeSelect.vue?vue&type=script&lang=js&"
import style0 from "./OrderTypeSelect.vue?vue&type=style&index=0&id=4600c6de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4600c6de",
  null
  
)

export default component.exports